import { useEffect } from 'react'

/**
 * Asks for confirmation before leaving the page while a process is running.
 *
 * @param isProcessRunning
 */
export function useConfirmOnPageExit(isProcessRunning: boolean) {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isProcessRunning) {
        event.preventDefault()
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [isProcessRunning])
}
